import { cloneDeep } from 'lodash';

export const form = () => cloneDeep({
  enabled: {
    label: 'Enabled',
    type: 'checkbox',
    value: 0,
    disabled: false,
    columnOptions: {
      md: 2,
    },
  },
  programme: {
    label: 'Programme',
    type: 'select',
    value: 'REG10 Door Programme',
    trackBy: 'programme',
    labelBy: 'programme',
    disabled: false,
    columnOptions: {
      md: 2,
    },
    options: [
      {
        programme: 'Annual Door Programme',
      },
      {
        programme: 'REG10 Door Programme',
      },
      {
        programme: 'Two Year Door Programme',
      },
    ],
    messages: [{
      type: 'warning',
      text: 'You must select a programme',
      show: form => form.programme.value === '',
    }],
  },
  propertyAssessmentTypeStatusId: {
    label: 'RA Availability',
    type: 'select',
    value: '',
    options: [],
    trackBy: 'propertyAssessmentTypeStatusId',
    labelBy: 'status',
    disabled: false,
    columnOptions: {
      md: 2,
    },
  },
  statusComment: {
    label: 'RA Availability Com.',
    type: 'text',
    value: '',
    columnOptions: {
      md: 6,
    },
  },
});
